import React from 'react';
import { Helmet } from 'react-helmet-async';
import Layout from '../components/Layout';
import Contact from '../components/Contact';
import CTA from '../components/CTA';

const ContactPage = () => {
  return (
    <Layout>
      <Helmet>
        <title>Contact Us - Adept Knowledge Technologies</title>
        <meta name="description" content="Get in touch with Adept Knowledge Technologies. Reach us for partnerships, research collaborations, and technology solutions. Based at PSG-STEP, Coimbatore, Tamil Nadu." />
        <link rel="canonical" href="https://www.ak-tech.in/contact" />
        <meta property="og:title" content="Contact Adept Knowledge Technologies" />
        <meta property="og:description" content="Reach us for partnerships, research collaborations, and technology solutions. Based at PSG-STEP, Coimbatore." />
        <meta property="og:url" content="https://www.ak-tech.in/contact" />
        <meta name="twitter:title" content="Contact Adept Knowledge Technologies" />
        <meta name="twitter:description" content="Reach us for partnerships, research collaborations, and technology solutions. Based at PSG-STEP, Coimbatore." />
      </Helmet>
      <Contact />
      <CTA />
    </Layout>
  );
};

export default ContactPage;